import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'
import Snowfall from 'react-snowfall'

import FrozoneImg from 'assets/images/letitgo/frozone.png'
import FrozoneImgMobile from 'assets/images/letitgo/frozone_mobile.png'
import ExchangeImg from 'assets/images/letitgo/exchange.png'
import Button1 from 'assets/images/token/join.png'
import Static from 'assets/images/letitgo/snowstorm.png'
import StaticMobile from 'assets/images/letitgo/snowstorm_mobile.png'
import useWindowDimensions from 'hooks/useDimensions'
// import { useHistory } from 'react-router'

const LetItGo: React.FC = () => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)
    const [isMobile1, setIsMobile1] = useState(false)
    // const history = useHistory()

    useEffect(() => {
        screenWidth > 767 ? setIsMobile(false) : setIsMobile(true)
        screenWidth > 1024 ? setIsMobile1(false) : setIsMobile1(true)
    }, [screenWidth])
    return (
        <StyledContainer>
            <Box position='relative' zIndex={1}>
                <Text>Ready to get</Text>
                <Text mt={1} color='#ffd80d'>First token?</Text>
                <RawText mb={isMobile ? '9px' : '0'}>ON</RawText>
                <img src={isMobile1 ? FrozoneImgMobile : FrozoneImg} alt='' />
                <img src={ExchangeImg} alt='' />
                <PresaleButton component='img' {...{ src: Button1 }} onClick={() => window.open('https://forms.gle/iwBvomru7fupQxKq7')} />
            </Box>
            {!isMobile ?
                <SnowBox>
                    <Snowfall snowflakeCount={200}/>
                </SnowBox>
                :
                <Snowfall snowflakeCount={100} style={{height: '100%'}} />
            }
            {!isMobile ?
                <Snowstatic />
                :
                <SnowstaticMobile />
            }
        </StyledContainer>
    )
}

const SnowstaticMobile = styled(Box)`
    position: absolute;
    top: 0;left:0;
    width: 100%;
    height: 100%;
    background-image: url(${StaticMobile});
    margin-top: 52px;
    background-size: 100% auto;
    background-repeat: no-repeat;
`

const Snowstatic = styled(Box)`
    position: absolute;
    top: 0;left:0;
    width: 100%;
    height: 100%;
    background-image: url(${Static});
    background-repeat: no-repeat;
    @media (min-width: 1441px) {
        background-size: 100% auto;
    }
`

const SnowBox = styled(Box)`
    width: 90%;
    height: 450px;
    position: absolute;
    top: 0;
    right: 0;
`

const PresaleButton = styled(Box)`
    margin-top: 57px;
    @media (max-width: 767px) {
        margin-top: 12px;
        height: 78.66px;
    }
    @media (max-width: 390px) {
        margin-top: 31px;
    }
    pointer-events: initial;
    cursor: pointer;
`

const RawText = styled(Box)`
    font-weight: 600;
    font-size: 36px;
    line-height: 80px;
    text-align: center;
    letter-spacing: -2px;
    text-transform: uppercase;
    color: #FFFFFF;
    @media (max-width: 390px) {
        margin-top: 70px;
        font-size: 24px;
        line-height: 20px;
    }
    @media (max-width: 360px) {
        margin-top: 24px;
        font-size: 18px;
        line-height: 20px;
    }
`

const Text = styled(Box)`
    font-weight: bold;
    font-size: 48px;
    line-height: 50px;
    @media (min-width: 767px) {
        font-size: 60px;
        line-height: 66px;
    }

    text-align: center;
    letter-spacing: -2px;
    text-transform: uppercase;

    color: #FFFFFF;

    text-shadow: 0px 4px 10px rgba(11, 24, 69, 0.71);
`

const StyledContainer = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    @media (min-width: 767px) {
        padding-right: 80px;
        justify-content: flex-end;
    }
    >div:first-of-type {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-top: 230px;
        @media (max-width: 767px) {
            padding-top: 360px;
        }
        @media (max-width: 360px) {
            padding-top: 277px;
        }
        >img:first-of-type {
            @media (max-width: 390px) {
                /* height: 61.84px; */
            }
        }
        >img:nth-of-type(2) {
            @media (max-width: 390px) {
                margin-top: 0;
            }
            @media (max-width: 360px) {
                height: 44px;
                margin-top: -20px;
            }
        }
    }
    /* >div:nth-of-type(2) {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    } */
`

export default LetItGo